import React, { Component } from 'react';
import {NavLink} from 'react-router-dom'
import Input from './Input'

class Form extends Component {
    render() { 
        let { loginError,username,password,disabledBtn, hideMessage ,handleChangeUsername , handleChangePassword} = this.props
        return ( 
            <div className="grid-cols-1">
            <div className="content-center px-12 py-12 mt-16 md:ml-48 md:mr-32 lg:mt-28 md:px-0">
                <div className="pb-2 text-center sm:text-left">
                    <span className="text-base font-semilight">Welcome To World Vision</span>
                    <h2 className="text-3xl font-extrabold text-gray-800 lg:text-2xl">Login To Your Account</h2>
                </div>
                <div className="mt-2">
                    <form onSubmit={this.props.handleSubmit}>
                        <Input
                         type="email"
                         label="email"
                         name="email"
                         id="email"
                         value={username}   
                         onChange={handleChangeUsername}                      
                         />
                        <Input
                         type="password"
                         label="password"
                         name="password"
                         value={password}                         
                         onChange={handleChangePassword}                      
                        />
                        <NavLink to="/password-reset" className="text-sm text-blue-500">
                         <span>Forgot Password?</span>
                        </NavLink>
                        <div className="mt-4 mb-6">
                            <button disabled={disabledBtn}   className={!disabledBtn ? "w-full px-3 py-3 text-white font-bold text-base bg-yellow-600 rounded-md" : "w-full px-3 py-3 text-white font-bold text-base bg-yellow-300 rounded-md"}>
                                {disabledBtn ? "Logging in ..." : "Login Now"}
                            </button>
                        </div>
                    </form>
                    
                </div>
                    {
                        loginError && 
                       <div className="flex justify-between p-4 bg-red-700 rounded-md">
                         <span className="text-sm text-center text-white">{loginError}</span>
                         <svg onClick={hideMessage} className="w-5 h-5 text-white cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
                       </div>
                    }

            </div>
        </div>
         );
    }
}
 
export default Form;